import {
  addRouteMiddleware,
  defineNuxtPlugin,
  useCookie,
  useRequestHeaders,
} from '#imports'
import {
  StorageKey,
  SupportLocale,
} from '~/types/enum'
import { DEFAULT_LOCALE } from '~/types/constants'

export const isSupportedLocale = (locale: string): locale is SupportLocale => Object
  .values<string>(SupportLocale)
  .includes(locale)

const getLocalFromHeader = () => {
  const key = 'accept-language'
  const acceptLanguage = useRequestHeaders([key])[key]

  if (!acceptLanguage) return

  return acceptLanguage.split(';')
    .map((el) => Object.values(SupportLocale)
      .find((local) => el.includes(local)))
    .filter((el) => el)[0]
}
export const getLocalFromNavigator = (): SupportLocale | undefined => {
  if (import.meta.server) return
  const locales = Object.values(SupportLocale)
  const locale = navigator.language
  if (isSupportedLocale(locale)) return locale
  return locales.find((el) => el.slice(0, 2) === locale.slice(0, 2)) || undefined
}

export const getLocale = () => {
  try {
    const locale = useCookie(StorageKey.LOCALE).value
      || getLocalFromHeader()
      || getLocalFromNavigator()

    if (locale && isSupportedLocale(locale)) return locale
    return DEFAULT_LOCALE
  } catch (err) {
    return DEFAULT_LOCALE
  }
}

export default defineNuxtPlugin(async nuxtApp => {
  const i18n = nuxtApp.$i18n as ReturnType<typeof import('vue-i18n').useI18n>
  addRouteMiddleware('set-locale-from-url', to => {
    const locale = to.query.locale as undefined | string
    if (locale && isSupportedLocale(locale)) {
      // 如果 query 中携带了语言，则优先使用 query 中的语言
      i18n.setLocale(locale)
    } else {
      // 如果当前 cookie 没有设置语言，将语言回写 cookie
      !i18n.getLocaleCookie() && i18n.setLocaleCookie(i18n.locale.value)
    }
  }, { global: true })
  return {
    provide: {
      t: i18n.t,
    },
  }
})
